import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { EXPERIMENT_ADD_TO_HOME_TIP } from '@constant/experiments';
import LaunchDarkly from '@module/launchdarkly';
import Browser from '@wetransfer/concorde-browser';

import AddToHomeTip from '@component/transfer/uploader/add-to-home-mobile';

import VideoIllustration from '@component/illustration/video-illustration';
import WithAnalytics from '@component/with-analytics';

import { methods as addToHomeTipMethodListeners } from '@app/analytics/add-to-home-mobile';

import I18n from '@module/i18n';

const AddToHomeTipWithAnalytics = WithAnalytics(
  {},
  {},
  addToHomeTipMethodListeners
)(AddToHomeTip);

const Email = ({ transfer, onRequestClose }) => {
  // How long before the transfer expires?
  const description =
    transfer.expiry === 'never'
      ? I18n.t('transfer.complete_email.text_no_expiry')
      : I18n.t('transfer.complete_email.text', {
          expires: I18n.relativeTime(transfer.expiry_seconds),
        });

  const title = transfer.isForward
    ? I18n.t('transfer.complete_forward.title')
    : I18n.t('transfer.complete_email.title');

  const shouldSeeExp =
    Browser.isMobile && LaunchDarkly.getVariant(EXPERIMENT_ADD_TO_HOME_TIP);
  const addToHomeComponent = shouldSeeExp ? (
    <AddToHomeTipWithAnalytics />
  ) : null;

  return (
    <React.Fragment key="email">
      <div className="transfer__contents">
        <VideoIllustration
          type="transfer-complete-upload"
          src="transfer_window/transfer_completed"
          variants={3}
          className="uploader__image"
        />
        <h2>{title}</h2>
        <p className="complete__text">{description}</p>
        <span className="transfer__contents--spacer" />
        {addToHomeComponent}
      </div>
      <div className="transfer__footer">
        <button className="transfer__button" onClick={onRequestClose}>
          {I18n.t('transfer.buttons.done')}
        </button>
      </div>
    </React.Fragment>
  );
};

Email.propTypes = {
  transfer: PropTypes.object.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

const mapStateToProps = ({ transfer }) => ({
  transfer,
});

export { Email };
export default connect(mapStateToProps)(Email);
